// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ec5bb43c","18":"69e72ac2","94":"ec6152bd","453":"165d36b4","611":"bf7e6c09","771":"18ff3370","896":"344d4dbc"}[chunkId] + ".chunk.js";
};